import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import { IStateCustomer } from "@/apps/merchant3/models/IStateCustomer";

export default {
  namespaced: true,
  state: {} as IStateCustomer,
  actions,
  getters,
  mutations,
};
